import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

import API from '../utils/api';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // CRITICAL: Prevent double processing under React StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id found in URL');
          navigate('/login');
          return;
        }

        // Exchange session_id for user session
        const { data } = await axios.post(
          `${API}/auth/google/session`,
          {},
          {
            headers: { 'X-Session-ID': sessionId },
            withCredentials: true
          }
        );

        // Update auth state before redirecting
        await checkAuth();

        // Session cookie is now set and auth state updated, redirect to dashboard
        navigate('/dashboard', { state: { user: data }, replace: true });
        
      } catch (error) {
        console.error('Google auth error:', error);
        navigate('/login', { state: { error: 'Authentication failed. Please try again.' } });
      }
    };

    processGoogleAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#F6F7FC] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-[#2D2560] border-r-transparent mb-4"></div>
        <p className="text-white/60">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
